import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

const usersRef = db.ref('users')
const userNameKeyRef = db.ref('_meta/namekeys/users')
const orderTypeRef = (currentUserId) => { return db.ref('users/' + currentUserId + '/userInfo/okrOrder') }

export const usersModule = {
  namespaced: true,
  state: {
    users: {},
    userNameKeys: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    // [getterConstants.SET_DEFAULT_USER_INFO]: firebaseAction((context, value) => {
    //   const setEmailRegistRef = db.ref('users')
    //   setEmailRegistRef.set(value)
    // }),
    [getterConstants.GET_USERS]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_USERS')
      bindFirebaseRef('users', usersRef, { wait: true })
    }),
    [getterConstants.GET_USER_NAME_KEY]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_USER_NAME_KEY')
      bindFirebaseRef('userNameKeys', userNameKeyRef, { wait: true })
    }),
    [getterConstants.SET_FOLLOWING_USERS]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const setFollowingUsersRef = db.ref('users/' + currentUserId + '/following/users')
      if (value.oldFollowingUsers) {
        for (let key in value.oldFollowingUsers) {
          // console.log(value[key])
          setFollowingUsersRef.child(value.oldFollowingUsers[key]).remove()
        }
      }
      if (value.users) {
        for (let key in value.users) {
          setFollowingUsersRef.child(value.users[key]).set(1)
        }
        // console.log(setFollowingUsersRef)
      }
    }),
    [getterConstants.SET_OKR_ORDER_TYPE]: firebaseAction((context, value) => {
      orderTypeRef(context.rootState.currentUserId).set(value)
    })
  },
  getters: {
    getUsers: state => state.users,
    getUserNameKeys: state => state.userNameKeys,
    getUserInfoById: state => userId => {
      // console.log('people/getUserInfoById:', userId)
      return state.users[userId] ? (state.users[userId].userInfo || {}) : {}
    },
    getUserById: state => userId => {
      return state.users[userId]
    },
    getUsersByIds: state => userIds => {
      let users = {}
      for (const userId of userIds) {
        if (state.users[userId]) {
          users[userId] = state.users[userId]
          users[userId].userId = userId
        }
      }
      return users
      /*
      let users = {}
      for (let user in state.users) {
        if (userIds.indexOf(user) >= 0) {
          users[user] = state.users[user]
          users[user].userId = user
        }
      }
      return users
      */
    },
    getUsersByText: (state, getters, rootState, rootGetters) => text => {
      let users = {}
      const regexp = new RegExp(text, 'i')
      const stateUserNameKeys = getters.getUserNameKeys
      const stateUsers = state.users
      const checkDeletedFunc = rootGetters['_meta/getMetaIsDeleted']
      let isDeveloper = rootGetters.getMetaIsDeveloper
      if (isDeveloper) {
        for (let user in stateUsers) {
          if (!stateUsers[user].userInfo || !stateUsers[user].userInfo.userName) {
            continue
          }
          if (stateUsers[user].userInfo.userName.match(regexp)) {
            users[user] = stateUsers[user]
          }
        }
      } else {
      // console.log('peoples:getUsersByText', stateUserNameKeys)
        for (let u in stateUserNameKeys) {
          if (checkDeletedFunc(u)) {
            continue
          }
          if (stateUserNameKeys[u].match(regexp)) {
            users[u] = getters.getUserById(u)
          }
        }
      }
      return users
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/users.js